import { render, staticRenderFns } from "./veStuAssocEdit copy.vue?vue&type=template&id=e4da36c6&scoped=true"
import script from "./veStuAssocEdit copy.vue?vue&type=script&lang=js"
export * from "./veStuAssocEdit copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4da36c6",
  null
  
)

export default component.exports